
        var result = require("!!../../../../node_modules/css-loader/index.js!./order-list-member.component.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./ClientApp/app/components/order-list-member/order-list-member.component.css
// module id = 621
// module chunks = 0